import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUri: 'https://register-test.plusmore.co.za/api',
  version: `qa-${packageJson.version}`,
  recaptchaKey: '6Lf7OgMsAAAAAPe9YG8rbYhmUWtFxKtOVHVJUV13',
};
